import { isSupportChatEmbedActive, toggleSupportChatOpen } from '../support-chat-embed';
import { cfgLiveChatLicenseId, cfgSupportChatMode } from '@infinitro/config';
import { toggleIntercom } from './intercom';
import { handleLiveChat } from './livechat';
const LIVECHAT_LICENSE = cfgLiveChatLicenseId() ?? '';
/** Shared support entry point used across the app (sidebar, footer, modals, etc.). */
export const handleCustomerSupport = (options) => {
    if (cfgSupportChatMode() === 'off') {
        return;
    }
    if (LIVECHAT_LICENSE) {
        handleLiveChat(options);
        return;
    }
    if (isSupportChatEmbedActive()) {
        toggleSupportChatOpen();
        return;
    }
    toggleIntercom();
};
